import { useState } from 'react';
import { logisticsResources } from '../../../mocks/logistics';

const LogisticsResources = () => {
  const [selectedType, setSelectedType] = useState('全部');
  
  const types = ['全部', '海运拼柜', '海运整柜', '空运', '高频小批量出口'];
  
  const filteredResources = selectedType === '全部' 
    ? logisticsResources 
    : logisticsResources.filter(resource => resource.type === selectedType);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-neutral-800 mb-4">
            物流资源展示
          </h2>
          <p className="text-lg text-neutral-600">
            按出口方式分类，展示但不"交底"
          </p>
        </div>

        {/* 筛选标签 */}
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          {types.map((type) => (
            <button
              key={type}
              onClick={() => setSelectedType(type)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                selectedType === type
                  ? 'bg-[#F7931E] text-white'
                  : 'bg-neutral-100 text-neutral-600 hover:bg-[#F7931E]/10 hover:text-[#F7931E]'
              }`}
            >
              {type}
            </button>
          ))}
        </div>

        {/* 物流资源卡片 */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredResources.map((resource) => (
            <div
              key={resource.id}
              className="bg-white rounded-xl border border-neutral-200 p-6 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-neutral-800">
                  {resource.type}
                </h3>
                {resource.supports1039 && (
                  <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded-full">
                    ✓ 熟悉1039
                  </span>
                )}
              </div>

              <div className="space-y-3 mb-6">
                <div>
                  <span className="text-sm text-neutral-500">覆盖口岸：</span>
                  <div className="flex flex-wrap gap-2 mt-1">
                    {resource.ports.map((port) => (
                      <span
                        key={port}
                        className="bg-blue-50 text-blue-600 text-xs px-2 py-1 rounded"
                      >
                        {port}
                      </span>
                    ))}
                  </div>
                </div>

                <div>
                  <span className="text-sm text-neutral-500">适配客户类型：</span>
                  <div className="flex flex-wrap gap-2 mt-1">
                    {resource.clientTypes.map((type) => (
                      <span
                        key={type}
                        className="bg-[#F7931E]/10 text-[#F7931E] text-xs px-2 py-1 rounded"
                      >
                        {type}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <p className="text-neutral-600 text-sm mb-4">
                {resource.description}
              </p>

              <div className="bg-neutral-50 rounded-lg p-3">
                <p className="text-xs text-neutral-500 text-center">
                  具体物流方案需结合业务结构评估后匹配
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogisticsResources;